/**
 * @file Migrations de sauvegarde ordonnees (vN -> vN+1), pures et testables. Aucun Object.assign sauvage : chaque etape est explicite.
 */
import { CURRENT_SAVE_VERSION } from './SaveSchema';

export type RawData = Record<string, unknown>;

export interface Migration {
  from: number;
  to: number;
  /** Description humaine (journal de changements du schema). */
  note: string;
  migrate(data: RawData): RawData;
}

/**
 * Liste ordonnee. Exemple pour une future v2 :
 *   { from: 1, to: 2, note: 'ajout de pets.slots', migrate: (d) => ({ ...d, pets: { ...(d.pets as RawData), slots: 3 } }) }
 */
export const MIGRATIONS: readonly Migration[] = [];

export class SaveVersionError extends Error {}

/** Applique les migrations de `version` jusqu'a CURRENT_SAVE_VERSION. Leve SaveVersionError si la sauvegarde est plus recente. */
export const migrateData = (data: RawData, version: number, migrations: readonly Migration[] = MIGRATIONS, target = CURRENT_SAVE_VERSION): RawData => {
  if (version > target) throw new SaveVersionError(`Save version ${version} is newer than supported ${target}`);
  let v = version;
  let d = data;
  while (v < target) {
    const m = migrations.find((x) => x.from === v);
    if (!m) throw new SaveVersionError(`No migration from v${v}`);
    d = m.migrate(d);
    v = m.to;
  }
  return d;
};
